// src/components/LoginPage.js
import React from "react";
import { useMsal } from "@azure/msal-react";
import { sharePointScopes } from "../authConfig";

export function LoginPage() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(sharePointScopes);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src="/assets/logo.png" alt="Stackroute | RPS" className="login-logo-img" />
        </div>
        <h1 className="login-title">NIIT Enterprise Solution Hub</h1>
        <p className="login-subtitle">
          Sign in with your Organization email ID to access the solution catalogue.
        </p>
        <button className="login-btn" onClick={handleLogin}>
          <svg width="20" height="20" viewBox="0 0 21 21" fill="none" aria-hidden="true">
            <rect x="1" y="1" width="9" height="9" fill="#f25022" />
            <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
            <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
          </svg>
          Sign in 
        </button>
        <p className="login-note">Internal use only — accessible to authorised personnel</p>
      </div>
    </div>
  );
}